import { useRef, useState } from "react";
import "./Book.css";

import { IonButton, IonCol, IonGrid, IonLoading, IonRow } from "@ionic/react";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import BasicPage from "../baseComponents/basicPage/BasicPage";
import PDFViewer from "./Viewer";
import { getTechno, getType, mapBook } from "./bookUtils";

interface Props {
  pathLogo: string;
}

const Book: React.FC<Props> = ({ pathLogo }) => {
  const urlParams = new URLSearchParams(window.location.search);

  const bookType = useRef(urlParams.get("type") ?? "");
  const techno = useRef(localStorage.getItem("techno") ?? "");
  const bookID = useRef(techno.current + "-" + bookType.current);

  const bookLink = mapBook.get(bookID.current);
  const hasLink = bookLink !== undefined && bookLink.length > 0;

  const [bookLoader, setBookLoader] = useState<boolean>(true);
  const ref = useRef<HTMLDivElement>(null);

  return (
    <BasicPage
      pathLogo={pathLogo}
      title={getTechno(techno.current)}
      subtitle={
        (localStorage.getItem("techno") !== "char"
          ? "Vous visionnez le livre de "
          : "") + getType(bookType.current)
      }
      pathReturn="welcome"
    >
      {hasLink ? (
        <div>
          <IonGrid>
            {window.location.href.includes("annee") && (
              <IonRow className="ion-justify-content-end">
                <IonCol size="5">
                  <div
                    className="btn no-padding"
                    onClick={() => {
                      window.location.href =
                        window.location.href.slice(0, -1) +
                        (window.location.href.includes("annee1") ? "2" : "1");
                    }}
                  >
                    Voir le livre de la{" "}
                    {window.location.href.includes("annee1") ? "2°" : "1°"}{" "}
                    année
                  </div>
                </IonCol>
              </IonRow>
            )}
          </IonGrid>
          <div
            style={{ overflow: "auto", maxHeight: "100vh" }}
            className="border-primary-contrast border-radius"
          >
            <IonLoading isOpen={bookLoader} message={"Chargement..."} />
            <div ref={ref} style={{ height: 500 }}>
              <PDFViewer
                fileURL={bookLink}
                setBookLoader={(isLoad) => setBookLoader(isLoad)}
              />
            </div>
          </div>
        </div>
      ) : (
        <IonGrid>
          <IonRow className="ion-justify-content-center">
            <IonButton disabled color="secondary" shape="round" strong>
              Le livre sera disponible prochainement
            </IonButton>
          </IonRow>
        </IonGrid>
      )}
    </BasicPage>
  );
};

export default Book;
